<template>
  <Modal
    v-model="visiable"
    :z-index="5001"
    title="自定义列"
    :width="720"
    class-name="c-custom-columns vertical-center-modal"
    @on-visible-change="bindGetData"
  >
    <Row :gutter="12">
      <Col span="15" style="max-height: 400px; overflow: auto">
        <template v-if="basic && basic.length">
          <Row class="row-item row-clearfix" v-if="subTitle && subTitle[0]">
            <Col span="5" class="col-item">
              <span class="item-field">{{ subTitle[0] }}</span>
            </Col>
            <Col span="19">
              <Checkbox :value="bcheckAll" @click.prevent.native="handleCheckAll('basic')">全选</Checkbox>
            </Col>
          </Row>
          <Row class="row-item" v-if="subTitle && subTitle[0]">
            <Col span="5" class="col-item">&nbsp;</Col>
            <Col span="19">
              <Checkbox
                v-for="(check, id) in basic"
                :key="id"
                v-model="check.show"
                :true-value="false"
                :false-value="true"
                @on-change="itemCheck(...arguments, check)"
                >{{ check.title }}</Checkbox
              >
            </Col>
          </Row>
        </template>
        <template v-if="disabled && disabled.length">
          <Row class="row-item row-clearfix" v-if="subTitle && subTitle[0]">
            <Col span="5" class="col-item">
              <span class="item-field">{{ subTitle[0] }}</span>
            </Col>
            <Col span="19">
              <Checkbox :value="dcheckAll" disabled @click.prevent.native="handleCheckAll('disabled')">全选</Checkbox>
            </Col>
          </Row>
          <Row class="row-item" v-if="subTitle && subTitle[0]">
            <Col span="5" class="col-item">&nbsp;</Col>
            <Col span="19">
              <Checkbox
                v-for="(check, id) in disabled"
                :key="id"
                v-model="check.show"
                disabled
                :true-value="false"
                :false-value="true"
                @on-change="itemCheck(...arguments, check)"
                >{{ check.title }}</Checkbox
              >
            </Col>
          </Row>
        </template>
        <Row class="row-item row-clearfix" v-if="subTitle && subTitle[1]">
          <Col span="5" class="col-item">
            <span class="item-field">{{ subTitle[1] }}</span>
          </Col>
          <Col span="19">
            <Checkbox :value="rcheckAll" @click.prevent.native="handleCheckAll('report')">全选</Checkbox>
          </Col>
        </Row>
        <Row class="row-item" v-if="subTitle && subTitle[1]">
          <Col span="5" class="col-item">&nbsp;</Col>
          <Col span="19">
            <Checkbox
              v-for="(check, id) in report"
              :key="id"
              v-model="check.show"
              :true-value="false"
              :false-value="true"
              @on-change="itemCheck(...arguments, check)"
              >{{ check.title }}</Checkbox
            >
          </Col>
        </Row>
        <Row class="row-item row-clearfix" v-if="subTitle && subTitle[2]">
          <Col span="5" class="col-item">
            <span class="item-field">{{ subTitle[2] }}</span>
          </Col>
          <Col span="19">
            <Checkbox :value="ocheckAll" @click.prevent.native="handleCheckAll('other')">全选</Checkbox>
          </Col>
        </Row>
        <Row class="row-item" v-if="subTitle && subTitle[2]">
          <Col span="5" class="col-item">&nbsp;</Col>
          <Col span="19">
            <Checkbox
              v-for="(check, id) in other"
              :key="id"
              v-model="check.show"
              :true-value="false"
              :false-value="true"
              @on-change="itemCheck(...arguments, check)"
              >{{ check.title }}</Checkbox
            >
          </Col>
        </Row>
        <Row class="row-item row-clearfix" v-if="subTitle && subTitle[3]">
          <Col span="5" class="col-item">
            <span class="item-field">{{ subTitle[3] }}</span>
          </Col>
          <Col span="19">
            <Checkbox :value="acheckAll" @click.prevent.native="handleCheckAll('analysis')">全选</Checkbox>
          </Col>
        </Row>
        <Row class="row-item" v-if="subTitle && subTitle[3]">
          <Col span="5" class="col-item">&nbsp;</Col>
          <Col span="19">
            <Checkbox
              v-for="(check, id) in analysis"
              :key="id"
              v-model="check.show"
              :true-value="false"
              :false-value="true"
              @on-change="itemCheck(...arguments, check)"
              >{{ check.title }}</Checkbox
            >
          </Col>
        </Row>
      </Col>
      <Col span="8" offset="1" class="r-box">
        <div class="box-head">
          <span>拖动排序 {{ result.length }} 列</span>
          <el-button type="text" v-if="result.length" @click="clear">清空全部</el-button>
        </div>
        <div class="box-body">
          <draggable v-model="result">
            <transition-group>
              <Tag v-for="item in result" :key="item.key" :name="item.key" closable @on-close="handleClose">{{ item.title }}</Tag>
            </transition-group>
          </draggable>
        </div>
      </Col>
    </Row>
    <div slot="footer">
      <Button type="default" @click="$emit('input', false)">取消</Button>
      <Button type="primary" @click="$emit('on-select', columns)">应用</Button>
    </div>
  </Modal>
</template>
<script>
import draggable from 'vuedraggable'
import { deepCopy } from '@/common/js/utils'
export default {
  name: 'customColumn',
  components: { draggable },
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    },
    subTitle: {
      type: Array,
      default() {
        return ['计划数据', '报表数据', '其他数据', '分析数据']
      }
    },
    dateType: {
      type: Number
    }
  },
  computed: {
    visiable: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    result: {
      get() {
        const columns = this.disabled && this.disabled.length ? this.columns.filter((ret) => ret.type !== 'disabled') : this.columns
        return columns.filter((ret) => !ret.show && !ret.fixed && ret.type).sort((a, b) => (a._time || 0) - (b._time || 0))
      },
      set(val) {
        val.forEach((column, i) => {
          const idx = this.columns.findIndex((ret) => ret.key === column.key)
          this.$set(this.columns[idx], '_time', Date.now() + i)
        })
      }
    },
    basic() {
      return this.columns.filter((ret) => ret.type === 'basic')
    },
    report() {
      // 综合报表为分日时显示，其他不显示
      const type = this.dateType
      const filterColumns =
        type === 2 || type === 3 || type === 4
          ? this.columns.filter((ret) => ret.type === 'report' && ret.key !== 'createRoleDays')
          : this.columns.filter((ret) => ret.type === 'report')
      return filterColumns
    },
    other() {
      return this.columns.filter((ret) => ret.type === 'other')
    },
    analysis() {
      return this.columns.filter((ret) => ret.type === 'analysis')
    },
    disabled() {
      const disabledArr = this.columns.filter((ret) => ret.type === 'disabled')
      disabledArr.forEach((item) => {
        this.$set(item, 'show', false)
      })
      return disabledArr
    },
    bcheckAll() {
      return this.basic.every((ret) => !ret.show)
    },
    rcheckAll() {
      return this.report.every((ret) => !ret.show)
    },
    ocheckAll() {
      return this.other.every((ret) => !ret.show)
    },
    acheckAll() {
      return this.analysis.every((ret) => !ret.show)
    },
    dcheckAll() {
      // return this.disabled.every(ret => !ret.show)
      return true
    }
  },
  methods: {
    bindGetData(val) {
      if (val) {
        this.columns = deepCopy(this.data)
      }
    },
    itemCheck() {
      const [val, column] = arguments
      if (!val) {
        const idx = this.columns.findIndex((ret) => ret.key === column.key)
        this.$set(this.columns[idx], '_time', Date.now())
      }
    },
    handleCheckAll(name) {
      let show
      if (name === 'basic') show = this.bcheckAll
      else if (name === 'report') show = this.rcheckAll
      else if (name === 'other') show = this.ocheckAll
      else if (name === 'analysis') show = this.acheckAll
      else if (name === 'disabled') show = this.dcheckAll
      this[name].forEach((ret, i) => {
        show && this.$set(ret, '_time', Date.now() + i)
        this.$set(ret, 'show', show)
      })
    },
    handleClose(e, name) {
      const idx = this.columns.findIndex((ret) => ret.key === name)
      this.$set(this.columns[idx], 'show', true)
    },
    clear() {
      this.columns.forEach((ret) => {
        if (!ret.fixed) this.$set(ret, 'show', true)
      })
    }
  },
  data() {
    return {
      columns: [] // 自定义列表数据
    }
  }
}
</script>
<style lang="scss" scoped>
.c-custom-columns {
  padding: 12px 0;

  .r-box {
    width: 200px;

    .box-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .box-body {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      max-height: 395px;

      ::v-deep .ivu-tag {
        width: 160px;
        user-select: none;

        i.ivu-icon-ios-close {
          float: right;
          display: inline-block;
          margin-top: 4px;
          margin-right: -2px;
        }
      }
    }
  }

  /* 表单选项 */
  .row-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 32px;

    .col-item {
      text-align: right;
    }

    i {
      margin-right: 4px;
      vertical-align: middle;

      &.ivu-icon-md-add {
        margin: 0;
      }
    }

    .item-field {
      font-size: 14px;
      padding-right: 12px;
    }
  }

  .row-clearfix {
    clear: both;
    margin-bottom: 12px;
  }
}
</style>
